import {Action} from '@ngrx/store';
import {ISickDay} from '@app/core/interfaces/sick-days.interface';
import {Pagination} from '@app/core/models/pagination.model';
import {ISickDayResponse} from '@app/core/interfaces/i-sick-day-response';
import {ISickDayAnswer} from '@app/core/interfaces/sick-day-answer';

export enum ESickDaysActions {
	GetSickDays = '[SickDays] Get Sick Days',
	GetSickDaysSuccess = '[SickDays] Get Sick Days Success',
	PostSickDay = '[SickDays] Post Sick Day',
	PostSickDaySuccess = '[SickDays] Post Sick Day Success',
	DeleteSickDay = '[SickDays] Delete Sick Day',
	DeleteSickDaySuccess = '[SickDays] Delete Sick Day Success',

	ApproveSickDay = '[SickDays] Approve Sick Day',
	ApproveSickDaySuccess = '[SickDays] Approve Sick Day Success',

	RespondSickDay = '[SickDays] Respond Sick Day',
	RespondSickDaySuccess = '[SickDays] Respond Sick Day Success',

	GetSickDayAnswers = '[SickDays] Get Sick Day Answers',
	GetSickDayAnswersSuccess = '[SickDays] Get Sick Day Answers Success',

	OpenCreateSickDayModal = '[SickDays] Open Create Sick Day Modal',
	OpenEmployeeSickDayAnswerModal = '[SickDays] Open Employee Sick Day Answer Modal',
	OpenSickDayAnswersModal = '[SickDays] Open Sick Day Answers Modal',
}

export class GetSickDays implements Action {
	public readonly type = ESickDaysActions.GetSickDays;

	constructor() {
	}
}

export class GetSickDaysSuccess implements Action {
	public readonly type = ESickDaysActions.GetSickDaysSuccess;

	constructor(public sickDays: ISickDay[], public pagination: Pagination) {
	}
}

export class PostSickDay implements Action {
	public readonly type = ESickDaysActions.PostSickDay;

	constructor(public payload: { shift_id: number, message: string }) {
	}
}

export class PostSickDaySuccess implements Action {
	public readonly type = ESickDaysActions.PostSickDaySuccess;

	constructor(public sickDay: ISickDay) {
	}
}

export class ApproveSickDay implements Action {
	public readonly type = ESickDaysActions.ApproveSickDay;

	constructor(public sickDay: ISickDay, public userId: number) {
	}
}

export class ApproveSickDaySuccess implements Action {
	public readonly type = ESickDaysActions.ApproveSickDaySuccess;

	constructor(public sickDay: ISickDay) {
	}
}

export class DeleteSickDay implements Action {
	public readonly type = ESickDaysActions.DeleteSickDay;

	constructor(public sickDay: ISickDay) {
	}
}

export class DeleteSickDaySuccess implements Action {
	public readonly type = ESickDaysActions.DeleteSickDaySuccess;

	constructor(public sickDay: ISickDay) {
	}
}

export class RespondSickDay implements Action {
	public readonly type = ESickDaysActions.RespondSickDay;

	constructor(public sickDay: ISickDay, public response: boolean) {
	}
}

export class RespondSickDaySuccess implements Action {
	public readonly type = ESickDaysActions.RespondSickDaySuccess;

	constructor(public response: ISickDayResponse) {
	}
}

export class GetSickDayAnswers implements Action {
	public readonly type = ESickDaysActions.GetSickDayAnswers;

	constructor(public sickDay: ISickDay) {
	}
}

export class GetSickDayAnswersSuccess implements Action {
	public readonly type = ESickDaysActions.GetSickDayAnswersSuccess;

	constructor(public answers: ISickDayAnswer[]) {
	}
}

export class OpenCreateSickDayModal implements Action {
	public readonly type = ESickDaysActions.OpenCreateSickDayModal;

	constructor(public shiftId: number, public date: string) {
	}
}

export class OpenEmployeeSickDayAnswerModal implements Action {
	public readonly type = ESickDaysActions.OpenEmployeeSickDayAnswerModal;

	constructor(public sickDay: ISickDay) {
	}
}

export class OpenSickDayAnswersModal implements Action {
	public readonly type = ESickDaysActions.OpenSickDayAnswersModal;

	constructor(public sickDay: ISickDay) {
	}
}

export type SickDaysActions =
	GetSickDays |
	GetSickDaysSuccess |
	PostSickDay |
	PostSickDaySuccess |
	OpenCreateSickDayModal |
	OpenEmployeeSickDayAnswerModal |
	OpenSickDayAnswersModal |
	GetSickDayAnswers |
	GetSickDayAnswersSuccess |
	ApproveSickDay |
	ApproveSickDaySuccess |
	DeleteSickDay |
	DeleteSickDaySuccess |
	RespondSickDay |
	RespondSickDaySuccess
	;
